import { createApiAction } from '@app/packages/api/utils'
import type { PostTrackingsRequest } from '@app/packages/api/v2/types/params'

/** A beacon: it must survive the page that sent it, and it must not delay anything the user sees. */
export const postTrackings = (request: PostTrackingsRequest, source: Record<string, string | object> = {}) =>
  createApiAction('postTrackings', dispatch =>
    dispatch<unknown>({
      method: 'POST',
      endpoint: '/api/v2/trackings',
      body: JSON.stringify({ ...source, ...request }),
      keepalive: true,
      priority: 'low',
    })
  )
